import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

const studies = [
  {
    company: "ContentGuard",
    headline: "From Twitter complaint to booked demo in 4 hours",
    metric: "2.4M messages moderated daily",
    body: "ContentGuard's Reply Agent surfaces public complaints about over-aggressive moderation, drafts a contextual reply, and routes it through a human reviewer in seconds.",
  },
  {
    company: "Flying Tiger",
    headline: "38 demos / month from public conversations",
    metric: "11s avg approval time",
    body: "Flying Tiger swapped paid search for Collavue and turned its support channel into a pipeline channel.",
  },
  {
    company: "Northpeak",
    headline: "+42% reply-to-demo conversion vs cold outbound",
    metric: "5 SDRs replaced by 1 Collavue workspace",
    body: "Northpeak collapsed five SDR seats into one workspace by letting Collavue handle discovery and drafting.",
  },
];

export default function CaseStudies() {
  return (
    <MarketingPage
      seo={{
        title: "Case Studies — Real teams, real pipeline, real receipts",
        description:
          "How ContentGuard, Flying Tiger, and Northpeak use Collavue to turn public conversations into booked demos and closed pipeline.",
        path: "/case-studies",
        keywords:
          "Collavue case studies, B2B AI lead generation case study, X lead generation case study, Twitter lead generation case study, LinkedIn lead generation case study, Reddit lead generation case study",
      }}
    >
      <PageHero
        eyebrow="Case studies"
        title="Real teams. Real pipeline."
        italicWord="Real receipts."
        description="The teams below replaced manual social monitoring and cold outbound with Collavue. Here's what changed."
      />

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-5">
          {studies.map((s) => (
            <article
              key={s.company}
              className="rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40 flex flex-col"
            >
              <div className="text-[#2d5bff] text-xs uppercase tracking-wider font-medium">
                {s.company}
              </div>
              <h2 className="font-display text-2xl text-[#0a1736] font-semibold mt-2">
                {s.headline}
              </h2>
              <p className="text-[#5a6478] text-sm mt-3 leading-relaxed flex-1">{s.body}</p>
              <div className="mt-5 pt-4 border-t border-[#e3dccb] text-sm text-[#0a1736] font-medium">
                {s.metric}
              </div>
            </article>
          ))}
        </div>

        <div className="max-w-7xl mx-auto px-6 pb-20">
          <Link
            to="/signup"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#0a1736] text-white font-medium hover:bg-[#1c2a4d]"
          >
            Run your own pipeline <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </MarketingPage>
  );
}
